import { useTrackDataFilters } from "../../../../utils/useTrackDataFilters";

/**
 * Hook to manage account and product filters for track location (Crew).
 * Thin wrapper around useTrackDataFilters with mode="crew".
 *
 * @param {Object} params
 * @param {Object} params.processedCarsMap - Map of trackId to cars array
 * @param {Object} params.selectedTrack - Currently selected track object
 * @param {Object} params.targetTrack - Target track object (tablet mode)
 * @param {Function} params.setSelectedShipmentIds - Function to clear selection when filter changes
 * @param {Function} params.setLastSelectedContext - Function to clear selection context
 * @param {Function} params.setSelectedShipment - Function to clear selected shipment
 * @returns {Object} Filter state and computed values
 */
export const useTrackLocationFilters = ({
  processedCarsMap,
  selectedTrack,
  targetTrack,
  setSelectedShipmentIds,
  setLastSelectedContext,
  setSelectedShipment,
}) => {
  return useTrackDataFilters({
    mode: "crew",
    processedCarsMap,
    selectedTrack,
    targetTrack,
    setSelectedShipmentIds,
    setLastSelectedContext,
    setSelectedShipment,
  });
};
